import { getLogger } from '../logger';

const logger = getLogger('react/utils/platform');

let gPlatform = null;

export const initialize = (platform) => {
  gPlatform = platform;
  logger.info('Platform=', platform);
};

export { gPlatform as default };
